<template>
  <b-modal
    id="ModalAlertaEmpresaHeader"
    header-class="modal-alerta-empresa-header modal-eraser-header title-atualizacao"
    body-class="modal-alerta-empresa-body"
    ok-title="Confirmar"
    footer-class="modal-alerta-empresa-footer"
    ok-variant="success"
    cancel-title="Cancelar"
    auto-focus-button
    hide-footer
  >
    <div slot="modal-header" class="title-area modal-alerta-empresa">
      <font-awesome-icon class="fa-3x" icon="exclamation-triangle" />
      <h5 class="modal-title" id="ModalAdicionarTitulo">ATUALIZAÇÃO DE CADASTRO</h5>
    </div>
    <div class="corpo-mensagem">
      <p>
        Prezado(a),
      </p>
      <p>
        Agora o cadastro de empresas conta com a informação da Unidade Federada (UF). Será
        necessário atualizar o cadastro da empresa para melhor experiência de uso da ferramenta.
      </p>
      <p>
        A informação da UF será utilizada na tela de Cenário, nos casos em que a empresa cadastrada
        esteja selecionada.
      </p>
      <p v-if="quantidade > 1">
        Atualize o cadastro de suas empresas
        <a class="link" @click="vaiParaEmpresa">clicando aqui</a>.
      </p>
      <p v-else>
        Atualize o cadastro de sua empresa
        <a class="link" @click="vaiParaEmpresa">clicando aqui</a>.
      </p>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "ModalAlerta",
  props: { quantidade: Number },
  created() {
    window.addEventListener("keydown", this.handleKey);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },

  methods: {
    handleKey(event) {
      let modal = document.getElementById("ModalAlertaEmpresaHeader");
      if (modal.classList.contains("show")) {
        if (event.key === "Enter") {
          this.$root.$emit("bv::hide::modal", "ModalAlertaEmpresaHeader");
        }
      }
    },
    vaiParaEmpresa() {
      this.$router.push("/empresas");
      this.$root.$emit("bv::hide::modal", "ModalAlertaEmpresaHeader");
    }
  }
};
</script>

<style lang="scss">
.title-atualizacao {
  background: var(--cinza0);
  border-bottom: 1px solid var(--cinza03) !important;
}
.modal-alerta-empresa-header {
  color: var(--vermelho3);
  background-color: var(--branco);
  border-bottom: 0;
  text-align: center;
}
.modal-alerta-empresa-header .modal-alerta-empresa {
  width: 100%;
}
.modal-alerta-empresa-header .modal-alerta-empresa button.close {
  position: absolute;
  top: 16px;
  right: 16px;
}
.modal-alerta-empresa-header .fa-times-circle {
  font-size: 70px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.modal-alerta-empresa-body {
  text-align: center;
  // margin-bottom: 15px;
}
.modal-alerta-empresa-footer button.btn-secondary {
  background: #9e9e9e !important;
  &:hover {
    background: #777777 !important;
  }
  &:focus {
    background: #777777 !important;
  }
}
.corpo-mensagem {
  color: var(--preto);
  text-align: center;
  margin-top: 7px;
  float: left;
  width: 100%;
  margin-bottom: 0px !important;
  p {
    text-align: left;
  }
}
.modal-alerta-empresa-footer button.btn-success {
  outline: 0 !important;
  background: #007bff !important;
  &:hover {
    background: #0069d9 !important;
  }
  &:focus {
    background: #0069d9 !important;
  }
}
.modal-alerta-empresa {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .fa-3x {
    svg {
      width: 50px;
      height: 50px;
    }
    margin-bottom: 10px;
    color: orange;
  }
}
.link {
  color: #0000ee !important;
  cursor: pointer;
  &:hover {
    text-decoration: underline !important;
  }
}
</style>
